import styled from 'styled-components';
import { breakpoints } from 'config/config';

export const StyledOrderPage = styled('div')`
  @media only screen and (max-width: ${breakpoints.lg}px) {
    .container {
      padding: 0;
    }
  }
`;
